import { CatalogProgressTextInputModel } from '../catalog-progress-text-input.model';
import { Injectable } from "@angular/core";
import { PlessHttp } from '../../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';

/**
 * 企画進捗管理テキストインプット初期値取得コマンドクラス
 *
 * @export GetCatalogProgressListService
 * @class GetCatalogProgressListService
 * @extends {PlessResponderSub}
 */
@Injectable()
export class GetCatalogProgressListService extends PlessJsonResponderSub<any> {

  // 処理に使用するModel
  private model: CatalogProgressTextInputModel;
  private mediumType: string = <string>'';
  private successFunc: Function;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof GetCatalogProgressListService
   */
  private getBody(): PlessRequest {
    return new PlessRequest({
      parameter: {
        MediumType: this.mediumType
      }
    });
  }

  /**
   * API呼び出し
   *
   * @param model
   * @param mediumType
   * @memberof GetCatalogProgressListService
   */
  execute(model: CatalogProgressTextInputModel, mediumType: string, successFunc: Function = null): void {
    this.model = model;
    this.mediumType = mediumType;
    this.successFunc = successFunc;
    this.send('KYMW02getCatalogProgressList', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof GetCatalogProgressListService
   */
  success(data: any): void {
    this.model.updateCatalogProgressList(data);
    if (this.successFunc !== null) {
      this.successFunc();
    }
  }

}
